import * as Api from './service'
import Moment from 'moment'
import { USER_STATUS } from '../consts'
const getTimerStr = strDate => Moment(strDate).valueOf() + ''

export default {
  namespace: 'scoreRecord',
  state: {
    currSelectIndex: 6,
    historyPointList: [
      // {
      //   date: getTimerStr(Moment().add('day', -3)),
      //   point: 23,
      //   expected: 100
      // },
      // {
      //   date: getTimerStr(Moment().add('day', -2)),
      //   point: 62,
      //   expected: 100
      // },
      // {
      //   date: getTimerStr(Moment().add('day', -1)),
      //   point: 75,
      //   expected: 100
      // },
      // { date: getTimerStr(Moment().valueOf()), point: 52, expected: 100 },
      // {
      //   date: getTimerStr(Moment().add('day', 1)),
      //   point: 82,
      //   expected: 100
      // },
      // {
      //   date: getTimerStr(Moment().add('day', 2)),
      //   point: 98,
      //   expected: 100
      // },
      // {
      //   date: getTimerStr(
      //     Moment()
      //       .add('day', 3)
      //       .valueOf()
      //   ),
      //   point: 77,
      //   expected: 100
      // }
    ]
  },
  effects: {
    * queryHistoryPointList ({ payload }, { call, put }) {
      let {
        data: { data }
      } = yield call(Api.queryHistoryPointList, payload)
      console.log(
        'data:orgin:',
        Moment(data[data.length - 1].dateTime).format('YYYY-MM-DD')
      )
      const currDate = Moment(data[data.length - 1].dateTime).valueOf()
      if (data.length < 7) {
        let dataLen = data.length
        let i = 0
        while (7 - dataLen) {
          const dataTime = Moment(currDate)
            .add('day', -i++)
            .valueOf()
          dataLen++
          data = [
            {
              point: 0,
              userStatus: USER_STATUS.abnormal,
              date: dataTime,
              expected: 100
            },
            ...data
          ]
        }
      }
      data.map((item, i) => {
        const lastItemIndex = data.length - 1
        item.index = i
        item.date = getTimerStr(
          Moment(data[lastItemIndex].dateTime)
            .add('day', -(lastItemIndex - i))
            .valueOf()
        )
        item.expected = 100
        delete item.dateTime
      })
      console.log('data', data)
      console.log(
        'curr',
        Moment(Number(data[data.length - 1].date)).format('YYY-MM-DD')
      )
      const currSelectIndex = data.length - 1
      yield put({
        type: 'save',
        payload: {
          historyPointList: data,
          currSelectIndex
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
